import { marked } from "marked";
import sanitizeHtml from "sanitize-html";

// Words from the page editor (markdown or simple HTML) -> safe HTML: only
// basic text tags and links survive, the same allow-list ContentSection uses.
export function safeMarkdown(text) {
    if (typeof text !== "string" || !text.trim()) return "";
    return sanitizeHtml(marked(text), {
        allowedTags: ["h3", "h4", "p", "ul", "ol", "li", "b", "i", "em", "strong", "a", "br"],
        allowedAttributes: { a: ["href", "target", "rel"] },
        allowedSchemes: ["http", "https", "mailto", "tel"],
    });
}
